export default __webpack_public_path__ + "static/media/mail.b7ee195e.png";